import React from 'react'
import MaskedInputComponent from 'react-text-mask'

import styles from '../../../../containers/Forms/Forms.css'

const MaskedInput = props => {
  const {
    input,
    meta: { touched, error, warning },
    label,
    getLabel,
    required,
    autoFocus,
    mask,
    placeholder,
    disabled,
    inline,
    type = 'text',
  } = props

  const inputComponent = typeof getLabel === 'function'
    ? getLabel()
    : <span className={styles.label}>{label}</span>

  const cn = inline ? styles.inputRowGroup : styles.inputGroup

  return (
    <label
      className={cn}
      htmlFor={input.name}
    >
      {required &&
        <span className={styles.required} />
      }
      {inputComponent}
      <MaskedInputComponent
        {...input}
        autoComplete="off"
        className={styles.input}
        type={type}
        disabled={disabled}
        required={required}
        id={input.name}
        mask={mask}
        autoFocus={autoFocus}
        placeholder={placeholder}
      />
      {warning && <span className={styles.error}>{warning}</span>}
      {error && <span className={styles.error}>{error}</span>}
    </label>
  )
}

export default MaskedInput



// WEBPACK FOOTER //
// ./src/legacy/containers/Forms/components/MaskedInput/MaskedInput.jsx